import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AmountOfPaymentGreaterThanDocumentValueError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.payment-list-items.amount-of-payment-greater-than-document-value');
    }
}
